// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"ce7c341e","75":"4b0b292d","147":"d0ce45f4","173":"02c3a331","243":"7c05a7d3"}[chunkId] + ".chunk.js";
};